import { useAxiosProvider } from "../components/AxiosProvider.js";
import { DocumentStatus } from "../patient-today-list.types.js";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { useQueryKey } from "../query-key-provider.js";
import "react/jsx-runtime";
import "react";
import "axios";
const deleteFactoringAgreement = (axios) => async (patientReferenceId) => {
  const { data } = await axios.delete(`/api/internal/patients/${patientReferenceId}/factoring-agreements/latest`);
  return data;
};
const handleOptimisticUpdate = (prevList, patientReferenceId) => {
  if (!prevList)
    return prevList;
  return prevList.map((item) => {
    if (item.patient.referenceId === patientReferenceId) {
      return {
        ...item,
        patientDocuments: {
          ...item.patientDocuments,
          factoring: {
            ...item.patientDocuments.factoring,
            status: DocumentStatus.IN_PROGRESS
          }
        }
      };
    }
    return item;
  });
};
const useRecollectFactoringAgreement = () => {
  const queryClient = useQueryClient();
  const { ana } = useAxiosProvider();
  const patientTodayLstQueryKey = useQueryKey();
  const { mutateAsync: recollectFactoringAgreement } = useMutation(deleteFactoringAgreement(ana), {
    onMutate: async (patientReferenceId) => {
      await queryClient.cancelQueries({ queryKey: patientTodayLstQueryKey });
      const prevList = queryClient.getQueryData(patientTodayLstQueryKey);
      queryClient.setQueryData(
        patientTodayLstQueryKey,
        (prevList2) => handleOptimisticUpdate(prevList2, patientReferenceId)
      );
      return { prevList };
    },
    onError: (_, __, context) => {
      queryClient.setQueryData(patientTodayLstQueryKey, context == null ? void 0 : context.prevList);
    }
  });
  return { recollectFactoringAgreement };
};
export {
  useRecollectFactoringAgreement
};
